import { render, staticRenderFns } from "./BindPhoneConfirm.vue?vue&type=template&id=d1ba0dba"
import script from "./BindPhoneConfirm.vue?vue&type=script&lang=js"
export * from "./BindPhoneConfirm.vue?vue&type=script&lang=js"
import style0 from "./BindPhoneConfirm.vue?vue&type=style&index=0&id=d1ba0dba&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/test-tripanels/clusterpanels/client-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1ba0dba')) {
      api.createRecord('d1ba0dba', component.options)
    } else {
      api.reload('d1ba0dba', component.options)
    }
    module.hot.accept("./BindPhoneConfirm.vue?vue&type=template&id=d1ba0dba", function () {
      api.rerender('d1ba0dba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_components/BindPhoneConfirm.vue"
export default component.exports